import { InstrumentType, InstrumentDefinition, TuningDefinition } from '../types';

export const BASS_STANDARD_TUNING: TuningDefinition = {
  id: 'bass-standard',
  label: 'Standard (Bass)',
  pitches: [
    { note: 'G', octave: 2 },
    { note: 'D', octave: 2 },
    { note: 'A', octave: 1 },
    { note: 'E', octave: 1 },
  ],
};

export const BASS_DEFINITION: InstrumentDefinition = {
  type: InstrumentType.Bass,
  name: 'Bass',
  defaultNumFrets: 24,
  defaultTunings: [BASS_STANDARD_TUNING],
};
